import React, { useEffect, useState } from 'react';
import moment from 'moment/moment';
import { EntryProps } from '../interface';
import { moment2String } from '@/pages/datalab/components/SortableDrag/utils';

import { TimeRangePicker } from '@/pages/datalab/components/FilterPicker/TimeRangePicker';

export const FilterTimeEntry = (props: EntryProps) => {
  const { column, onChange, isEn } = props;
  const [timeValue, setTimeValue] = useState<any[]>(column.column_value ?? []);

  useEffect(() => {
    let columnValues = column.column_value ?? [];
    if (columnValues.length === 0) {
      const endTime = moment();
      const beginTime = moment().subtract(6, 'day');
      columnValues = [moment2String(beginTime, undefined), moment2String(endTime, undefined)];
    }
    setTimeValue(columnValues);
  }, [JSON.stringify(column.column_value)]);

  useEffect(() => {
    onChange('between', timeValue);
  }, [JSON.stringify(timeValue)]);

  return (
    <>
      <span className="fs-entry-text-prefix" style={{ marginRight: '10px' }}>
        {isEn ? "on" : "在"}
      </span>
      <TimeRangePicker
        value={timeValue}
        onConfirmBack={(value: any) => {
          setTimeValue(value);
        }}
        language={isEn ? "en" : "cn"}
      />
    </>
  );
};
